import { Component, input, output } from '@angular/core';
import { dsDtos, dsEnums } from '@vectronic/openApi-admin';
import {
  CardComponent,
  ChipsFilterWithHeaderComponent,
  InputFilterWithHeaderComponent,
  SelectionFilterWithHeaderComponent,
} from '@vectronic/ui';
import { FilterItemWithLabel } from '@vectronic/util';

@Component({
  selector: 'rc-schedule-template-filter',
  templateUrl: './schedule-template-filter.component.html',
  styleUrls: ['./schedule-template-filter.component.scss'],
  imports: [
    CardComponent,
    ChipsFilterWithHeaderComponent,
    InputFilterWithHeaderComponent,
    SelectionFilterWithHeaderComponent,
  ],
})
export class ScheduleTemplateFilterComponent {
  InputFilterWithHeaderComponent = InputFilterWithHeaderComponent;

  searchFilter = input<dsDtos.SearchScheduleTemplateAdmin>();
  availableUserAccounts = input<FilterItemWithLabel<number>[]>([]);

  templateNameChange = output<string>();
  scheduleTypeChange = output<dsEnums.ScheduleType | undefined>();
  userIdsChange = output<number[]>();

  availableScheduleTypes: FilterItemWithLabel<dsEnums.ScheduleType>[] = [
    { item: 'GPS', label: 'Gps, Proximity, VF' },
    { item: 'VHF', label: 'Beacon' },
    { item: 'COMMUNICATION', label: 'Communication' },
    { item: 'CAMERA', label: 'Camera' },
  ];

  onScheduleTypeChange(value: dsEnums.ScheduleType | undefined) {
    this.scheduleTypeChange.emit(value);
  }

  onTemplateNameChange(value: string) {
    this.templateNameChange.emit(value);
  }

  onUserIdsChange(value: number[]) {
    this.userIdsChange.emit(value);
  }
}
